const WA_NUMBER = "526675723329";

export const waLink = (msg) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;

export const WA_GENERAL = waLink(
  "Hola ANGORA MATERIALES, quiero cotizar materiales para mi proyecto. ¿Me pueden apoyar?"
);

export const waProduct = (name) =>
  waLink(`Hola ANGORA MATERIALES, me interesa cotizar: ${name}. ¿Me pueden apoyar con precio y disponibilidad?`);

export const PHONE_DISPLAY = "+52 667 572 3329";
export const ADDRESS = "Carretera Mochis–Topolobampo km 15.2, Parque Industrial Topolobampo, Nave 18, CP 81377, Los Mochis, Sinaloa, México";
export const MAPS_URL = "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent("Carretera Mochis-Topolobampo km 15.2, Parque Industrial Topolobampo Nave 18, 81377 Los Mochis, Sinaloa");

const P = "/assets/products/";

export const CATEGORIES = [
  {
    id: "laminas",
    index: "S.01",
    name: "Láminas & Rollos",
    tagline: "Nuestra especialidad — fabricación propia",
    products: [
      { slug: "lamina-galvanizada", name: "Lámina Galvanizada", spec: "Lisa cal. 16 a 32 · Acanalada cal. 22 a 32 · recubrimiento de zinc", img: P + "galv-tint.jpg", pos: "center" },
      { slug: "lamina-acanalada", name: "Lámina Acanalada", spec: "Cal. 22 a 32 · galvanizada y pintro · largos a medida", img: P + "u-lamina.jpg", pos: "center" },
      { slug: "lamina-pintro", name: "Lámina Pintro", spec: "Prepintada en colores · doble capa de pintura · alta duración", img: P + "lamina-pintro.jpg", pos: "center" },
      { slug: "lamina-antiderrapante", name: "Lámina Antiderrapante", spec: "Placa estriada para pisos, rampas y plataformas", img: P + "lamina-antiderrapante.jpg", pos: "center" },
      { slug: "losacero", name: "Losacero", spec: "Secciones 20 y 25 · colado de azoteas y entrepisos", img: P + "losacero-real.jpg", pos: "center" },
      { slug: "rollo-lamina", name: "Rollo de Lámina", spec: "Rollo galvanizado, negro y pintro · anchos comerciales", img: P + "rollo2.jpg", pos: "center" },
    ],
  },
  {
    id: "perfiles",
    index: "S.02",
    name: "Perfiles & Tubos",
    tagline: "Estructura para todo tipo de obra",
    products: [
      { slug: "ptr", name: "Perfil PTR", spec: "Tubo rectangular y cuadrado · perfiles cuadrados cal. 14 a 18", img: P + "ptr-real.jpg", pos: "center" },
      { slug: "tubo-galvanizado", name: "Tubo Galvanizado", spec: "Cédula 30 y 40 · protección anticorrosiva", img: P + "ptr.jpg", pos: "center" },
      { slug: "tubo-negro", name: "Tubo Negro", spec: "Redondo cédula 40 · usos estructurales e industriales", img: P + "u-tubos.jpg", pos: "center" },
      { slug: "polines", name: "Polines", spec: "Polín montén con fondo anticorrosivo rojo · carga, impacto y retorno", img: P + "polin-real.jpg", pos: "center" },
      { slug: "canal-monten", name: "Viga IPR / IPS", spec: "Perfil IR e IPS · trabes y viguetas para techos y estructuras", img: P + "n-viga.jpg", pos: "center" },
      { slug: "angulo", name: "Ángulo de Acero", spec: "Atados de ángulos de lados iguales · marcos y soportes", img: P + "angulo-real.jpg", pos: "center" },
      { slug: "solera-cuadro", name: "Solera", spec: "Solera 1/8\" x 1\" en tramos de 6 m · más medidas y calibres", img: P + "solera-real.jpg", pos: "center" },
    ],
  },
  {
    id: "estructurales",
    index: "S.03",
    name: "Estructurales & Obra",
    tagline: "Material pesado para proyectos serios",
    products: [
      { slug: "viga-ipr", name: "Viga IPR", spec: "Atados de vigas IPR · claros grandes y estructuras principales", img: P + "viga-real.jpg", pos: "center" },
      { slug: "placa-acero", name: "Placa de Acero", spec: "Espesores de 1/8\" a 2\" · corte a medida", img: P + "placa-real.jpg", pos: "center" },
      { slug: "varilla", name: "Varilla Corrugada", spec: "Grado 42 · 3/8\" a 1\" · armado de concreto", img: P + "varilla-real.jpg", pos: "center" },
      { slug: "alambre-cable", name: "Alambre y Cable", spec: "Alambre recocido, galvanizado y cable de acero", img: P + "alambre-real.jpg", pos: "center" },
    ],
  },
];
